import {
  RETENTION_PERIOD_DAYS_MAX,
  RETENTION_PERIOD_MONTHS_MIN,
  RETENTION_PERIOD_MONTHS_START_INDEX,
  RETENTION_PERIOD_YEARS_MIN,
  RETENTION_PERIOD_YEARS_START_INDEX,
  type KeepUnit
} from '../config/upload';

export interface RetentionPeriodResult {
  unit: KeepUnit;
  amount: number;
}

export function sliderIndexToRetentionPeriod(index: number): RetentionPeriodResult {
  if (index <= RETENTION_PERIOD_DAYS_MAX) {
    return { unit: 'd', amount: index };
  }

  if (index < RETENTION_PERIOD_YEARS_START_INDEX) {
    const offset = index - RETENTION_PERIOD_MONTHS_START_INDEX;
    return { unit: 'm', amount: RETENTION_PERIOD_MONTHS_MIN + offset };
  }

  const yearsOffset = index - RETENTION_PERIOD_YEARS_START_INDEX;
  return { unit: 'y', amount: RETENTION_PERIOD_YEARS_MIN + yearsOffset };
}

export function buildRetentionPeriodCode(unit: KeepUnit, amount: number): string {
  const padded = String(amount).padStart(3, '0');
  return `${padded}${unit}`;
}

export function computeExpiresAtIso(unit: KeepUnit, amount: number): string {
  let days = 0;
  if (unit === 'd') {
    days = amount;
  } else if (unit === 'm') {
    days = amount * 30;
  } else {
    days = amount * 365;
  }

  const now = new Date();
  const expires = new Date(now.getTime() + days * 24 * 60 * 60 * 1000);
  return expires.toISOString();
}
